import { Box, Stack } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { useAuthUser } from 'auth/hooks';
import { CompanySettingsLayout, UomConversionAudit } from 'companySettings/components';
import { canAccessCompanySettings } from 'companySettings/utils';
import { Error, PageLayout, PageTitle } from 'core/components';
import { StatusCode } from 'core/constants';

export const UomConversionAuditPage = () => {
  const { t } = useTranslation();

  const { user, isLoading } = useAuthUser();

  const title = t('titleUomConversionAudit');

  // Same reasoning as Approved Vendors: `user` is hydrated synchronously from localStorage, so
  // deciding on `isLoading` keeps the grid (and its report request) from mounting before the gate.
  if (isLoading) {
    return <PageLayout title={title} />;
  }

  // Same gate as every other Company Settings page. A dedicated corporate resource was tried and
  // dropped: the section is only reachable through a menu entry that is itself company-admin-only,
  // so granting the permission to another role bought nothing but a URL.
  if (!canAccessCompanySettings(user)) {
    return (
      <PageLayout title={title}>
        <Error statusCode={StatusCode.ACCESS_DENIED} />
      </PageLayout>
    );
  }

  return (
    <CompanySettingsLayout title={title}>
      {/* The layout hands its child a box of exactly the remaining height. This page
          puts a heading in that box as well as the report, so the two share it as a
          flex column — otherwise the report's own 100% height is measured against the
          whole box and the grid overflows by the height of the heading, pushing the
          table's Total/Filtered footer past the bottom of the window with no way to
          scroll to it. */}
      <Stack sx={{ height: '100%', minHeight: 0 }}>
        <PageTitle title={title} />

        <Box sx={{ flexGrow: 1, minHeight: 0 }}>
          <UomConversionAudit />
        </Box>
      </Stack>
    </CompanySettingsLayout>
  );
};
